import { c as _c } from "react/compiler-runtime";
import Container from "@components/Container";
import reveal from "@modules/homepage-v2/components/Reveal/reveal.module.css";
import { SCROLL_MARGIN } from "@modules/homepage-v2/lib/anchors";
import type { PageSection } from "@modules/homepage-v2/lib/getSections";
import { PropsWithChildren } from "react";
export type Ground = "white" | "tinted";
export const GROUNDS: Record<Ground, string> = {
  white: "bg-neutral-0",
  tinted: "bg-neutral-12"
};
export const groundsFor = (sections: PageSection[], first: Ground = "white"): Ground[] => {
  let previous: Ground | null = null;
  let next: Ground = first;
  return sections.map(section => {
    if (section.__component === "sections-v2.final-cta") {
      return previous ?? next;
    }
    const melts = section.__component === "sections-v2.logo-marquee" || section.__component === "sections-v2.bank-logo-row" && ("variant" in section ? section.variant : undefined) !== "band";
    if (melts && previous) {
      return previous;
    }
    previous = next;
    next = next === "white" ? "tinted" : "white";
    return previous;
  });
};
const Section = t0 => {
  const $ = _c(7);
  const {
    ground,
    id,
    reveals: t1,
    children
  } = t0;
  const reveals = t1 === undefined ? true : t1;
  const t2 = `${GROUNDS[ground]} py-xl m:py-5xl ${id ? SCROLL_MARGIN : ""}`;
  const t3 = reveals ? reveal.reveal : undefined;
  let t4;
  if ($[0] !== children || $[1] !== t3) {
    t4 = <Container padding={true} className={t3}>{children}</Container>;
    $[0] = children;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== id || $[4] !== t2 || $[5] !== t4) {
    t5 = <section id={id} className={t2}>{t4}</section>;
    $[3] = id;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export default Section;